import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { setupMock } from './mock'
import App from './App.vue'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import 'animate.css'
import './assets/css/tailwind.css'
import * as echarts from 'echarts'
import axios from 'axios'

// 导入FontAwesome图标
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faUser, faCog, faChartLine, faBrain, 
  faUpload, faSearch, faBell, faSignOutAlt,
  faList, faThLarge, faEye, faFilter,
  faPlay, faPause, faStop, faFileExport,
  faSave, faSync, faPlug, faUnlink,
  faLink, faUserPlus, faMobile, faTrash,
  faCloudUploadAlt, faCheckCircle, faBatteryThreeQuarters,
  faLock, faArrowRight, faEdit, faChevronRight, faInfoCircle
} from '@fortawesome/free-solid-svg-icons'

import '@fortawesome/fontawesome-free/css/all.min.css'


// 添加图标到库
library.add(
  faUser, faCog, faChartLine, faBrain, 
  faUpload, faSearch, faBell, faSignOutAlt,
  faList, faThLarge, faEye, faFilter,
  faPlay, faPause, faStop, faFileExport,
  faSave, faSync, faPlug, faUnlink,
  faLink, faUserPlus, faMobile, faTrash,
  faCloudUploadAlt, faCheckCircle, faBatteryThreeQuarters,
  faLock, faArrowRight, faEdit, faChevronRight, faInfoCircle
)

import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 导入Element Plus图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)
app.use(ElementPlus)

// 注册所有Element Plus图标组件
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.component('font-awesome-icon', FontAwesomeIcon)
app.use(router)

// 全局注册echarts
app.config.globalProperties.$echarts = echarts

// 捕获并忽略ResizeObserver错误（不影响功能的已知问题）
const resizeObserverErr = window.console.error
window.console.error = (...args: any[]) => {
  if (
    args[0] &&
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop completed with undelivered notifications')
  ) {
    return
  }
  resizeObserverErr.call(window.console, ...args)
}

// 在创建axios实例后添加
axios.interceptors.request.use(config => {
  const token = localStorage.getItem('authToken')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
}, error => {
  return Promise.reject(error)
})


setupMock()

app.mount('#app')